export class StockValuationModel {
    product : string
    noOfcartons : number
    packStyle:string
    qtyInKgs : number
    qtyInLbs : number
    costPerKg : number
    totalValue: number

    constructor(product : string,noOfcartons : number,packStyle:string,qtyInKgs : number,qtyInLbs : number,costPerKg : number,totalValue: number){
        this.product  = product 
        this.noOfcartons  = noOfcartons 
        this.packStyle = packStyle
        this.qtyInKgs  = qtyInKgs 
        this.qtyInLbs  = qtyInLbs 
        this.costPerKg  = costPerKg 
        this.totalValue = totalValue
    }
}